import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from './IconBase';
const paths = ['M3,1h19c1.1,0,2,0.9,2,2v17c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V3C1,1.9,1.9,1,3,1z', 'M7,1h15c1.1,0,2,0.9,2,2v17c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2V3C5,1.9,5.9,1,7,1z', 'M11,1h11c1.1,0,2,0.9,2,2v17c0,1.1-0.9,2-2,2H11c-1.1,0-2-0.9-2-2V3C9,1.9,9.9,1,11,1z'];
const Path = props => React.createElement("path", {
  fill: "none",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  stroke: props.color || '#FFFFFF',
  d: props.path
});
const MyWalletIcon = props => React.createElement(IconBase, _extends({
  viewBox: "0 0 25 23.4",
  style: {
    enableBackground: 'new 0 0 25 23.4'
  }
}, props), React.createElement("g", null, React.createElement("g", null, paths.map(path => React.createElement(Path, _extends({
  key: path,
  path: path
}, props))), React.createElement("text", {
  "font-Size": "14px",
  "aria-hidden": "true",
  fontFamily: "Roboto-Bold",
  fill: props.color || '#FFFFFF',
  transform: "matrix(1 0 0 1 12.36 17)"
}, "$"))));
MyWalletIcon.displayName = 'MyWalletIcon';
export default MyWalletIcon;
//# sourceMappingURL=MyWalletIcon.js.map